<template>
    <div class="form-group" :class="base_class">
        <label class="form-label d-block">{{ title }}</label>
        
        <div class="btn-group btn-group-toggle" role="radiogroup">
            <label
                v-for="(item, idx) in draw_radio_options"
                :key="idx"
                class="btn btn-outline-primary"
                :class="{ active: localValue === item.value }"
            >
                <input
                    :id="localId"
                    type="radio"
                    class="d-none"
                    :name="radioGroupName"
                    :value="item.value"
                    v-model="localValue"
                />
                {{ item.text }}
            </label>
        </div>
    </div>
</template>

<script>
export default {
    name: "yes_no",
    
    props: {
        modelValue: {
            type: [Boolean, String, Number],
            default: false,
        },
        
        title: {
            type: String,
            default: "",
        },
        
        base_class: {
            type: String,
            default: "",
        },
        
        radio_options: {
            type: Array,
            default() {
                return [
                    { text: "Так", value: true },
                    { text: "Ні", value: false },
                ];
            },
        },
    },
    data() {
        return {
            localId: 'yn-' + Math.random().toString(36).slice(2)
        }
    },
    computed: {
   
        localValue: {
            get() {
                return this.modelValue;
            },
            set(val) {
                this.$emit("update:modelValue", val);
            },
        },
        
        radioGroupName() {
            return `radio-${this._uid}`;
        },
        
        draw_radio_options() {
            return this.radio_options;
        },
    },
};
</script>

<style scoped>
.btn.active {
    z-index: 1;
}
</style>